import app from '../app.first';

app.ListingFilter = class extends app.Component {
	onReady($this) {
		let typingTimer = '';
		let ajaxFilter = $('.ajaxFilter');
		$('.ajaxFilter').addClass('border-filter');

		ajaxFilter.on('keyup', function () {
			clearTimeout(typingTimer);
			typingTimer = setTimeout($(this).filterAdminResults, '150');
		});
		ajaxFilter.on('keydown', function () {
			clearTimeout(typingTimer);
		});

		let ajaxTextFilter = $('.ajaxTextFilter');
		ajaxTextFilter.on('keyup', function () {
			clearTimeout(typingTimer);
			typingTimer = setTimeout($(this).filterAdminResults, '150');
		});
		ajaxTextFilter.on('keydown', function () {
			clearTimeout(typingTimer);
		});

		$('select.ajaxSelectFilter').on('change', function () {
			$(this).filterAdminResults();
		});

		$('.ajaxSelectFilter[type=text]').on('change', function () {
			$(this).filterAdminResults();
		});

		$('.ajaxDateFilter').on('change', function () {
			$(this).filterAdminResults();
		});

		$('.ajaxSelectFilter[type=checkbox]').on('change', function () {
			$(this).filterAdminResults();
		});

		$('.ajaxCheckboxFilter').on('change', function () {
			$(this).filterAdminResults();
		});

		$("<span class='sort-arrow fa fa-caret-up'></span>").insertAfter("a.asc");
		$("<span class='sort-arrow fa fa-caret-down'></span>").insertAfter("a.desc");

		$.fn.filterAdminResults = function (filter) {
			$('.loaderImage').show();
			var data = {
				search: ajaxFilter.val() || ''
			};

			var tmp = [];
			$('.ajaxSelectFilter').each(function (i, e) {
				if ($(this).attr('type') != 'checkbox') {
					data[$(this).attr('name')] = $(this).val();
				} else {
					if (this.checked === true) {
						tmp.push($(this).val());
						data[$(this).attr('name')] = tmp;
					}
				}
			});


			$('.ajaxTextFilter').each(function () {
				data[$(this).attr('name')] = $(this).val();
			});

			$('.ajaxCheckboxFilter').each(function () {
				data[$(this).attr('name')] = this.checked ? 1 : 0;
			});

			$('.ajaxDateFilter').each(function () {
				data[$(this).attr('name')] = $(this).val();
			});

			$.ajax({
				url: window.location.origin + window.location.pathname,
				data: data,
				success: function (response) {
					$('.listing').html($(response).find('.listing').html());

					$('.loaderImage').hide();

					if ($(".pika-day").length) {
						// setDatePickers();
					}

					// update the url in addressbar
					if (history.pushState) {
						var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + $.param(data);

						$('.clearButton').removeClass('d-none');

						if ($(".exportLink").length) {
							var exportLink = newurl.replace('?', '.csv?')
							$(".exportLink").prop('href', exportLink)
						}

						if ($(".exportButton").length) {
							var exportLink = newurl.replace('?', '.csv?')
							$(".exportButton").prop('href', exportLink)
							$(".exportButton").html('Export Filtered View');
						}

						window.history.pushState({ path: newurl }, '', newurl);

					}
				}
			});
		}

		function setDatePickers() {
			var picker = [];
			$('.pika-day').each(function(index, element) {

				var field_type = $(this).data("field-type");
				let show_time = false;
				let date_format = 'YYYY-MM-DD';
				if (field_type == 'datetime') {
					show_time = true;
					date_format = 'YYYY-MM-DD HH:mm:ss';
				}

				picker[index] = new Pikaday({
					field: element,
					format: date_format,
					use24hour: false,
					showTime: show_time
				});
			});

			$('.ajaxDateFilter').on('change', function () {
				$(this).filterAdminResults();
			});
		}
	}
}
